// utils/auth.ts
import { MSAL } from '@/plugins/msal/msal'

export const getAccessToken = async (msal: MSAL): Promise<string | null> => {
  // 1. Try to get token from cookies
  const cookieToken = getCookie('access-token')
  if (cookieToken) {
    return atob(cookieToken)
  }

  // 2. Try to get token from sessionStorage
  const sessionToken = sessionStorage.getItem('access-token')
  if (sessionToken) {
    return sessionToken
  }

  // 3. Acquire new token if not found
  try {
    const tokenResponse = await msal.acquireToken()
    const accessToken = tokenResponse?.accessToken || null

    if (accessToken) {
      setCookie('access-token', btoa(accessToken), 30) // 30 minutes
      return accessToken
    } else {
      console.warn('Failed to acquire token')
      return null
    }
  } catch (error) {
    console.error('Error acquiring token:', error)
    return null
  }
}

// Helper to read a cookie by name
function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'))
  return match ? decodeURIComponent(match[2]) : null
}

// Helper to set a cookie
function setCookie(name: string, value: string, minutes: number) {
  const expires = new Date(Date.now() + minutes * 60 * 1000).toUTCString()
  document.cookie = `${name}=${encodeURIComponent(
    value
  )}; expires=${expires}; path=/; secure; samesite=Strict`
}
